import { trpc } from "../trpc";
import useAccountRestriction from "../account/useAccountRestriction";
import { Approval, ApprovalsOrder } from "@zapier/bff";
import { useCanApprove } from "./useCanApprove";

interface Input {
  enabled?: boolean;
  order?: ApprovalsOrder | undefined;
  zapId?: string;
  isLoadingForApprovalModal?: boolean;
}

interface Return {
  approvals: Approval[];
  isLoading: boolean;

  totalCount: number;
}

function useApprovals({
  enabled = true,
  order,
  zapId,
  isLoadingForApprovalModal,
}: Input): Return {
  const { isPublishApprovalEnabled, isLoading: isAccountRestrictionLoading } =
    useAccountRestriction();
  const { canApprove, isLoading: isCanApproveLoading } = useCanApprove();

  const { data, isLoading: isApprovalsLoading } =
    trpc.approval.approvals.useQuery(
      { order, zapId },
      {
        enabled:
          enabled &&
          !isAccountRestrictionLoading &&
          !!isPublishApprovalEnabled &&
          (isLoadingForApprovalModal ?? (!isCanApproveLoading && canApprove)),
      },
    );

  return {
    approvals: data?.approvals ?? [],
    isLoading: isApprovalsLoading || isAccountRestrictionLoading,
    totalCount: data?.totalCount ?? 0,
  };
}

export default useApprovals;
